/**
 * @file Deletes TOFU MCP tool-grant docs for a rotated agent-chat session.
 * Grants live at `users/{uid}/agentChat/current/mcpGrants/{sessionId}_{toolName}`
 * and are written by the cloud_run admin SDK on first-use approval; this
 * best-effort cleanup runs from `AIProvider.clearMessages` so stale grants do
 * not accumulate past the session that earned them. Failures are logged and
 * swallowed rather than blocking session rotation.
 */
import { collection, deleteDoc, getDocs, query, where } from 'firebase/firestore';
import { firestore } from './startFirestore';

export async function deleteMcpGrantsForSession(uid: string, sessionId: string): Promise<void> {
    if (!uid || !sessionId) return;
    try {
        const grantsRef = collection(firestore, `users/${uid}/agentChat/current/mcpGrants`);
        const sessionQuery = query(grantsRef, where('sessionId', '==', sessionId));
        const snapshot = await getDocs(sessionQuery);
        await Promise.allSettled(snapshot.docs.map(grantDoc => deleteDoc(grantDoc.ref)));
    } catch (error) {
        console.error('Failed to clean up MCP grants for session:', sessionId, error);
    }
}
